(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-it-works-new"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.currentScript.closest('[data-hiw]');
  if (!section) return;
  const wrap = section.querySelector('[data-hiw-wrap]');
  if (!wrap) return;

  /* ── Drag to scroll (desktop) ── */
  let isDown = false, startX, scrollLeft;

  wrap.addEventListener('mousedown', (e) => {
    isDown = true;
    wrap.classList.add('is-dragging');
    startX = e.pageX - wrap.offsetLeft;
    scrollLeft = wrap.scrollLeft;
  });
  wrap.addEventListener('mouseleave', () => { isDown = false; wrap.classList.remove('is-dragging'); });
  wrap.addEventListener('mouseup',    () => { isDown = false; wrap.classList.remove('is-dragging'); });
  wrap.addEventListener('mousemove',  (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - wrap.offsetLeft;
    wrap.scrollLeft = scrollLeft - (x - startX);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonialreviewscarousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.currentScript.closest('[data-rr]');
  if (!root) return;

  const wrap = root.querySelector('[data-rr-wrap]');
  const hint = root.querySelector('[data-rr-hint]');

  if (!wrap || !hint) return;

  const update = () => {
    hint.hidden = !(wrap.scrollWidth > wrap.clientWidth + 8 && wrap.scrollLeft < 8);
  };

  update();
  wrap.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.currentScript.closest('[data-video-row]');
  if (!section) return;

  const vids = section.querySelectorAll('video.video-embed');

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const v = entry.target;
      v.muted = true;
      v.playsInline = true;
      v.loop = true;

      if (entry.isIntersecting) {
        if (v.readyState < 2) v.load();
        const tryPlay = () => v.play().catch(() => {});
        if (v.readyState >= 2) tryPlay();
        else v.addEventListener('loadeddata', tryPlay, { once: true });
      } else {
        v.pause();
      }
    });
  }, { root: null, threshold: 0.15 });

  vids.forEach(v => io.observe(v));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.currentScript.closest('[data-video-row]');
  if (!section) return;

  const vids = section.querySelectorAll('video.video-embed');

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const v = entry.target;
      v.muted = true;
      v.playsInline = true;
      v.loop = true;

      if (entry.isIntersecting) {
        if (v.readyState < 2) v.load();
        const tryPlay = () => v.play().catch(() => {});
        if (v.readyState >= 2) tryPlay();
        else v.addEventListener('loadeddata', tryPlay, { once: true });
      } else {
        v.pause();
      }
    });
  }, { root: null, threshold: 0.15 });

  vids.forEach(v => io.observe(v));
})();

  } catch(e) { console.error(e); }
})();
})();
